"use client";

import { useEffect } from "react";
import { useToast } from "./ui/Toast";

export function Flash({ error, message }: { error?: string | null; message?: string | null }) {
  const { dismissToast, showToast } = useToast();

  useEffect(() => {
    if (message) {
      showToast({ tone: "success", message });
    }
  }, [message, showToast]);

  useEffect(() => {
    if (!error) {
      return undefined;
    }

    const toastId = showToast({ tone: "danger", message: error });

    return () => dismissToast(toastId);
  }, [dismissToast, error, showToast]);

  return null;
}
